const highSchoolCourses = {
  SSREAL: [
    'ID-F001',
    'ID-F002',
    'ID-F003',
    'ID-F004',
    'ID-F005',
    'ID-F006a',
    'ID-F006b',
    'ID-F007',
    'ID-F008',
    'ID-F008a',
    'ID-F008b',
    'ID-F009',
    'ID-F010',
    'ID-P001',
    'ID-P002',
    'ID-P003',
    'ID-P004',
    'ID-P005',
    'ID-P006',
    'ID-P007',
    'ID-P008',
    'ID-P009',
    'ID-P010',
    'ID-P011',
    'ID-P012',
    'ID-P013',
    'ID-P014',
    'ID-P015',
    'ID-P016',
    'ID-P017',
    'ID-P018',
    'ID-P019',
  ],
  SSSAMF: [
    'ID-F001',
    'ID-F002',
    'ID-F003',
    'ID-F004',
    'ID-F005',
    'ID-F006a',
    'ID-F006b',
    'ID-F007',
    'ID-F008',
    'ID-F008a',
    'ID-F008b',
    'ID-F009',
    'ID-F010',
    'ID-P020',
    'ID-P021',
    'ID-P022',
    'ID-P023',
    'ID-P024',
    'ID-P025',
    'ID-P026',
    'ID-P027',
    'ID-P028',
    'ID-P029',
    'ID-P030',
    'ID-P031',
    'ID-P032',
    'ID-P033',
    'ID-P034',
    'ID-P035',
    'ID-P036',
    'ID-P037',
    'ID-P038',
    'ID-P039',
    'ID-P040',
    'ID-P041',
    'ID-P042',
    'ID-P043',
    'ID-P044',
    'ID-P045',
    'ID-P046',
    'ID-P047',
    'ID-P048',
    'ID-P049',
    'ID-P050',
    'ID-P051',
    'ID-P052',
    'ID-P053',
    'ID-P054',
    'ID-P055',
    'ID-P056',
    'ID-P057',
    'ID-P130',
    'ID-P131',
    'ID-P132',
  ],
  MK: [
    'ID-F001',
    'ID-F002',
    'ID-F003',
    'ID-F004',
    'ID-F005',
    'ID-F006a',
    'ID-F006b',
    'ID-F007',
    'ID-F008',
    'ID-F008a',
    'ID-F008b',
    'ID-F009',
    'ID-F010',
    'ID-P078',
    'ID-P079',
    'ID-P080',
    'ID-P081',
    'ID-P082',
    'ID-P083',
  ],
  MUS: [
    'ID-F001',
    'ID-F002',
    'ID-F003',
    'ID-F004',
    'ID-F006a',
    'ID-F006b',
    'ID-F007',
    'ID-F008',
    'ID-F008a',
    'ID-F008b',
    'ID-F009',
    'ID-F010',
    'ID-P090',
    'ID-P091',
    'ID-P092',
    'ID-P093',
    'ID-P094',
    'ID-P095',
    'ID-P096',
    'ID-P097',
    'ID-P104',
    'ID-P105',
    'ID-P106',
    'ID-P107',
    'ID-P108',
    'ID-P109',
    'ID-P110',
    'ID-P111',
    'ID-P117',
    'ID-P118',
    'ID-P119',
    'ID-P120',
    'ID-P121',
    'ID-P122',
    'ID-P123',
  ],
  IL: [
    'ID-F001',
    'ID-F002',
    'ID-F003',
    'ID-F004',
    'ID-F006a',
    'ID-F006b',
    'ID-F007',
    'ID-F008',
    'ID-F008a',
    'ID-F008b',
    'ID-F009',
    'ID-F010',
    'ID-P058',
    'ID-P059',
    'ID-P060',
    'ID-P061',
    'ID-P062',
    'ID-P063',
    'ID-P064',
    'ID-P065',
    'ID-P066',
    'ID-P067',
  ],
  YRK: [
    'ID-F001',
    'ID-F004b',
    'ID-F005',
    'ID-F006c',
    'ID-F006d',
    'ID-F007a',
    'ID-F007b',
    'ID-F008',
    'ID-F008a',
    'ID-F008b',
    'ID-F010',
  ],
  '235': [
    'ID-F001',
    'ID-F001a',
    'ID-F001b',
    'ID-F004',
    'ID-F004b',
    'ID-F006a',
    'ID-F006b',
    'ID-F006c',
    'ID-F006d',
    'ID-F007',
    'ID-F007a',
    'ID-F007b',
    'ID-F008',
    'ID-F008a',
    'ID-F008b',
    'ID-F010',
    'ID-P001',
    'ID-P002',
    'ID-P003',
    'ID-P004',
    'ID-P006',
    'ID-P007',
    'ID-P008',
    'ID-P009',
    'ID-P010',
    'ID-P011',
    'ID-P013',
    'ID-P014',
    'ID-P015',
    'ID-P016',
    'ID-P018',
    'ID-P019',
    'ID-P021',
    'ID-P022',
    'ID-P023',
    'ID-P024',
    'ID-P030',
    'ID-P031',
    'ID-P032',
    'ID-P130',
    'ID-P131',
    'ID-P132',
  ],
  '235YRK': [
    'ID-F001',
    'ID-F001a',
    'ID-F001b',
    'ID-F004b',
    'ID-F006c',
    'ID-F006d',
    'ID-F007',
    'ID-F007a',
    'ID-F007b',
    'ID-F008',
    'ID-F008a',
    'ID-F008b',
    'ID-F010',
  ],
  HO: [
    'ID-F001',
    'ID-F004b',
    'ID-F005',
    'ID-F006c',
    'ID-F006d',
    'ID-F007a',
    'ID-F007b',
    'ID-F008',
    'ID-F008a',
    'ID-F008b',
    'ID-F010',
    'ID-P133',
    'ID-P134',
    'ID-P135',
    'ID-P136',
    'ID-P137',
    'ID-P138',
    'ID-P139',
    'ID-P140',
    'ID-P149',
    'ID-P150',
    'ID-P151',
    'ID-P152',
    'ID-P153',
    'ID-P154',
    'ID-P155',
  ],
  ED: [
    'ID-F001',
    'ID-F004b',
    'ID-F005',
    'ID-F006c',
    'ID-F006d',
    'ID-F007a',
    'ID-F007b',
    'ID-F008',
    'ID-F008a',
    'ID-F008b',
    'ID-F010',
    'ID-P139',
    'ID-P140',
    'ID-P141',
    'ID-P142',
    'ID-P143',
    'ID-P144',
    'ID-P145',
    'ID-P146',
    'ID-P147',
    'ID-P148',
  ],
  FBIE: [
    'ID-F001',
    'ID-F004b',
    'ID-F005',
    'ID-F006c',
    'ID-F006d',
    'ID-F007a',
    'ID-F007b',
    'ID-F008',
    'ID-F008a',
    'ID-F008b',
    'ID-F010',
    'ID-P139',
    'ID-P140',
    'ID-P156',
    'ID-P157',
    'ID-P158',
    'ID-P159',
    'ID-P160',
    'ID-P161',
    'ID-P162',
    'ID-P163',
  ],
  IM: [
    'ID-F001',
    'ID-F004b',
    'ID-F005',
    'ID-F006c',
    'ID-F006d',
    'ID-F007a',
    'ID-F007b',
    'ID-F008',
    'ID-F008a',
    'ID-F008b',
    'ID-F010',
    'ID-P139',
    'ID-P140',
    'ID-P164',
    'ID-P165',
    'ID-P166',
    'ID-P167',
    'ID-P168',
    'ID-P169',
    'ID-P170',
    'ID-P171',
    'ID-P172',
  ],
  SSR: [
    'ID-F001',
    'ID-F004b',
    'ID-F005',
    'ID-F006c',
    'ID-F006d',
    'ID-F007a',
    'ID-F007b',
    'ID-F008',
    'ID-F008a',
    'ID-F008b',
    'ID-F010',
    'ID-P139',
    'ID-P140',
    'ID-P173',
    'ID-P174',
    'ID-P175',
    'ID-P176',
    'ID-P177',
    'ID-P178',
    'ID-P179',
    'ID-P180',
    'ID-P181',
  ],
}

export const allFellesFag = [
  'ID-F001',
  'ID-F001a',
  'ID-F001b',
  'ID-F002',
  'ID-F003',
  'ID-F004',
  'ID-F004a',
  'ID-F004b',
  'ID-F005',
  'ID-F006',
  'ID-F006a',
  'ID-F006b',
  'ID-F006c',
  'ID-F006d',
  'ID-F007',
  'ID-F007a',
  'ID-F007b',
  'ID-F008',
  'ID-F008a',
  'ID-F008b',
  'ID-F009',
  'ID-F010',
]

export default highSchoolCourses
